const cards: NodeListOf<HTMLAnchorElement> = document.querySelectorAll(".adsComponent-card");

if (cards && cards.length > 0) {
  const cardButtons: NodeListOf<HTMLButtonElement> = document.querySelectorAll(".adsComponent-card__button");

  cards.forEach(card => {
    card.addEventListener("click", e => {
      const target = e.target as HTMLElement;

      if (target.classList.contains("button") || target.classList.contains("button__image")) {
        e.preventDefault()
      }
    });
  });

  cardButtons.forEach(button => {
    button.addEventListener("click", e => {
      //console.log("small button clicked")
    })
  })
}
